import { RepairDamagedImageCard } from './repairDamagedImageCard';
import { RepairDamagedImageInfoType } from '@/types/bodyAndPaint';

interface RepairDamagedImageProps {
  data: RepairDamagedImageInfoType[];
}
export const RepairDamagedImage = ({ data }: RepairDamagedImageProps) => {
  return (
    <div className={'repair-damaged-image-field'}>
      {Array.isArray(data) &&
        data.map((imageInfo, idx) => (
          <RepairDamagedImageCard info={imageInfo} key={idx} />
        ))}
    </div>
  );
};
